// Lightweight translation dictionary for landing page key copy.
// Falls back to English for missing keys/languages.

const TRANSLATIONS = {
  en: {
    nav_find_stars: "I'm Brand",
    nav_categories: "Categories",
    nav_earnings: "Earnings",
    btn_login: "Login",
    btn_join_free: "Join Free",
    hero_tag: "Verified Stars Ready to Work",
    hero_title_1: "Where Brands Find",
    hero_title_2: "Their Star",
    hero_subtitle: "Models • Actors • Influencers • Dancers • Photographers",
    hero_cta_find: "I'm Brand",
    hero_cta_be: "I'm Creator",
    hero_safe: "🔒 Your data is safe with us",
    trust_escrow: "Secure Escrow",
    trust_verified: "Verified Profiles",
    trust_free: "Free to Join",
    section_browse: "Browse by Category",
    section_browse_sub: "Find the perfect star for your project",
    section_all_stars: "All Stars",
    section_stars_available: "Stars available",
    filters_btn: "Filters",
    filter_all_categories: "All Categories",
    filter_city: "City",
    filter_city_placeholder: "Enter city...",
    filter_budget: "Budget Range",
    section_calc_title: "Earnings Calculator",
    section_calc_sub: "See what you can earn on FOUNDSTAR",
    lang_changed: "Language changed",
  },
  hi: {
    nav_find_stars: "मैं ब्रांड हूं",
    nav_categories: "श्रेणियाँ",
    nav_earnings: "कमाई",
    btn_login: "लॉगिन",
    btn_join_free: "मुफ्त जुड़ें",
    hero_tag: "वेरिफाइड स्टार्स काम के लिए तैयार",
    hero_title_1: "जहाँ ब्रांड्स ढूंढते हैं",
    hero_title_2: "अपना स्टार",
    hero_subtitle: "मॉडल्स • अभिनेता • इन्फ्लुएंसर्स • डांसर्स • फोटोग्राफर्स",
    hero_cta_find: "मैं ब्रांड हूं",
    hero_cta_be: "मैं क्रिएटर हूं",
    hero_safe: "🔒 आपका डेटा हमारे पास सुरक्षित है",
    trust_escrow: "सुरक्षित एस्क्रो",
    trust_verified: "वेरिफाइड प्रोफाइल्स",
    trust_free: "मुफ्त जॉइन",
    section_browse: "श्रेणी से ब्राउज़ करें",
    section_browse_sub: "अपने प्रोजेक्ट के लिए सही स्टार खोजें",
    section_all_stars: "सभी स्टार्स",
    section_stars_available: "स्टार्स उपलब्ध",
    filters_btn: "फ़िल्टर",
    filter_all_categories: "सभी श्रेणियाँ",
    filter_city: "शहर",
    filter_city_placeholder: "शहर दर्ज करें...",
    filter_budget: "बजट रेंज",
    section_calc_title: "कमाई कैलकुलेटर",
    section_calc_sub: "देखें FOUNDSTAR पर आप कितना कमा सकते हैं",
    lang_changed: "भाषा बदली",
  },
  mr: {
    nav_find_stars: "स्टार्स शोधा",
    nav_categories: "श्रेणी",
    nav_earnings: "कमाई",
    btn_login: "लॉगिन",
    btn_join_free: "मोफत सामील व्हा",
    hero_tag: "व्हेरिफाइड स्टार्स कामासाठी तयार",
    hero_title_1: "जिथे ब्रँड्स शोधतात",
    hero_title_2: "त्यांचा स्टार",
    hero_subtitle: "मॉडेल्स • अभिनेते • इन्फ्लुएंसर्स • डान्सर्स • फोटोग्राफर्स",
    hero_cta_find: "स्टार्स शोधा",
    hero_cta_be: "स्टार बना",
    hero_safe: "🔒 तुमचा डेटा आमच्याकडे सुरक्षित आहे",
    trust_escrow: "सुरक्षित एस्क्रो",
    trust_verified: "व्हेरिफाइड प्रोफाइल्स",
    trust_free: "मोफत जॉईन",
    section_browse: "श्रेणीनुसार पहा",
    section_browse_sub: "तुमच्या प्रोजेक्टसाठी योग्य स्टार शोधा",
    section_all_stars: "सर्व स्टार्स",
    section_stars_available: "स्टार्स उपलब्ध",
    filters_btn: "फिल्टर",
    filter_all_categories: "सर्व श्रेणी",
    filter_city: "शहर",
    filter_city_placeholder: "शहर टाका...",
    filter_budget: "बजेट रेंज",
    section_calc_title: "कमाई कॅल्क्युलेटर",
    section_calc_sub: "FOUNDSTAR वर तुम्ही किती कमावू शकता ते पहा",
    lang_changed: "भाषा बदलली",
  },
  ta: {
    nav_find_stars: "ஸ்டார்களைக் கண்டறி",
    nav_categories: "வகைகள்",
    nav_earnings: "வருமானம்",
    btn_login: "உள்நுழை",
    btn_join_free: "இலவசமாக சேரு",
    hero_tag: "சரிபார்க்கப்பட்ட ஸ்டார்கள் தயார்",
    hero_title_1: "பிராண்டுகள் கண்டறியும்",
    hero_title_2: "தங்கள் ஸ்டாரை",
    hero_subtitle: "மாடல்கள் • நடிகர்கள் • இன்ஃப்ளூயன்சர்கள் • நடனக் கலைஞர்கள் • புகைப்படக்காரர்கள்",
    hero_cta_find: "ஸ்டார்களைக் கண்டறி",
    hero_cta_be: "ஸ்டார் ஆகு",
    hero_safe: "🔒 உங்கள் தரவு எங்களுடன் பாதுகாப்பானது",
    trust_escrow: "பாதுகாப்பான எஸ்க்ரோ",
    trust_verified: "சரிபார்க்கப்பட்ட சுயவிவரங்கள்",
    trust_free: "இலவச பதிவு",
    section_browse: "வகை வாரியாக பார்வையிடவும்",
    section_browse_sub: "உங்கள் திட்டத்திற்கான சரியான ஸ்டாரைக் கண்டறியவும்",
    section_all_stars: "அனைத்து ஸ்டார்கள்",
    section_stars_available: "ஸ்டார்கள் கிடைக்கின்றன",
    filters_btn: "வடிகட்டிகள்",
    filter_all_categories: "அனைத்து வகைகள்",
    filter_city: "நகரம்",
    filter_city_placeholder: "நகரத்தை உள்ளிடவும்...",
    filter_budget: "பட்ஜெட் வரம்பு",
    section_calc_title: "வருமான கால்குலேட்டர்",
    section_calc_sub: "FOUNDSTAR இல் நீங்கள் என்ன சம்பாதிக்கலாம் என்று பார்க்கவும்",
    lang_changed: "மொழி மாற்றப்பட்டது",
  },
  te: {
    nav_find_stars: "స్టార్‌లను కనుగొనండి",
    nav_categories: "విభాగాలు",
    nav_earnings: "ఆదాయం",
    btn_login: "లాగిన్",
    btn_join_free: "ఉచితంగా చేరండి",
    hero_tag: "ధృవీకరించబడిన స్టార్‌లు సిద్ధం",
    hero_title_1: "బ్రాండ్‌లు కనుగొనే చోటు",
    hero_title_2: "వారి స్టార్",
    hero_subtitle: "మోడల్స్ • నటులు • ఇన్‌ఫ్లుయెన్సర్‌లు • డ్యాన్సర్‌లు • ఫోటోగ్రాఫర్‌లు",
    hero_cta_find: "స్టార్‌లను కనుగొనండి",
    hero_cta_be: "స్టార్ అవ్వండి",
    hero_safe: "🔒 మీ డేటా మాతో సురక్షితం",
    trust_escrow: "సురక్షిత ఎస్క్రో",
    trust_verified: "ధృవీకరించబడిన ప్రొఫైళ్లు",
    trust_free: "ఉచిత చేరిక",
    section_browse: "విభాగం వారీగా బ్రౌజ్ చేయండి",
    section_browse_sub: "మీ ప్రాజెక్ట్‌కు సరైన స్టార్‌ను కనుగొనండి",
    section_all_stars: "అన్ని స్టార్‌లు",
    section_stars_available: "స్టార్‌లు అందుబాటులో",
    filters_btn: "ఫిల్టర్లు",
    filter_all_categories: "అన్ని విభాగాలు",
    filter_city: "నగరం",
    filter_city_placeholder: "నగరాన్ని నమోదు చేయండి...",
    filter_budget: "బడ్జెట్ పరిధి",
    section_calc_title: "ఆదాయ కాలిక్యులేటర్",
    section_calc_sub: "FOUNDSTAR లో మీరు ఎంత సంపాదించవచ్చో చూడండి",
    lang_changed: "భాష మార్చబడింది",
  },
  gu: {
    nav_find_stars: "સ્ટાર્સ શોધો",
    nav_categories: "શ્રેણીઓ",
    nav_earnings: "કમાણી",
    btn_login: "લોગિન",
    btn_join_free: "મફત જોડાઓ",
    hero_tag: "વેરિફાઇડ સ્ટાર્સ કામ માટે તૈયાર",
    hero_title_1: "જ્યાં બ્રાન્ડ્સ શોધે છે",
    hero_title_2: "તેમના સ્ટાર",
    hero_subtitle: "મોડેલ્સ • કલાકારો • ઇન્ફ્લુએન્સર્સ • ડાન્સર્સ • ફોટોગ્રાફર્સ",
    hero_cta_find: "સ્ટાર્સ શોધો",
    hero_cta_be: "સ્ટાર બનો",
    hero_safe: "🔒 તમારો ડેટા અમારી પાસે સુરક્ષિત છે",
    trust_escrow: "સુરક્ષિત એસ્ક્રો",
    trust_verified: "વેરિફાઇડ પ્રોફાઇલ્સ",
    trust_free: "મફત જોડાવો",
    section_browse: "શ્રેણી દ્વારા બ્રાઉઝ કરો",
    section_browse_sub: "તમારા પ્રોજેક્ટ માટે યોગ્ય સ્ટાર શોધો",
    section_all_stars: "બધા સ્ટાર્સ",
    section_stars_available: "સ્ટાર્સ ઉપલબ્ધ",
    filters_btn: "ફિલ્ટર્સ",
    filter_all_categories: "બધી શ્રેણીઓ",
    filter_city: "શહેર",
    filter_city_placeholder: "શહેર દાખલ કરો...",
    filter_budget: "બજેટ રેન્જ",
    section_calc_title: "કમાણી કેલ્ક્યુલેટર",
    section_calc_sub: "FOUNDSTAR પર તમે કેટલી કમાણી કરી શકો છો તે જુઓ",
    lang_changed: "ભાષા બદલાઈ",
  },
};

export const getLang = () => {
  try {
    return localStorage.getItem("foundstar_lang") || "en";
  } catch {
    return "en";
  }
};

export const setLang = (code) => {
  try {
    localStorage.setItem("foundstar_lang", code);
  } catch {
    // ignore
  }
};

export const t = (key, lang) => {
  const code = lang || getLang();
  return (TRANSLATIONS[code] && TRANSLATIONS[code][key]) || TRANSLATIONS.en[key] || key;
};

export default TRANSLATIONS;
